import { RootStateOrAny } from "react-redux";
import { AnyAction } from "redux";

import {
  FETCH_INTERVIEWERS_REQUEST,
  FETCH_INTERVIEWERS_SUCCESS,
  FETCH_INTERVIEWERS_FAILURE,
  CLEAR_INTERVIEWERS,
} from "./actionTypes";
import { LOGOUT } from '../auth/actionType';

export const initialState = {
  isLoading: false,
  didSucceed: null,
  error: "",
  interviewers: [],
};

const reducer = (
  state: RootStateOrAny = initialState,
  action: AnyAction
): object => {
  const { type, payload } = action;
  switch (type) {
    case FETCH_INTERVIEWERS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_INTERVIEWERS_SUCCESS:
      return {
        ...state,
        didSucceed: true,
        isLoading: false,
        interviewers: payload.interviewers,
      };
    case FETCH_INTERVIEWERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        didSucceed: false,
        error: payload.error,
      };
    case LOGOUT:
    case CLEAR_INTERVIEWERS:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
